/**
 * useMinWidth(px) — true while the window is at least `px` wide.
 *
 * For layouts that must stack on a phone (two columns become one, a header's
 * side buttons move above the title). Re-checks when the window is resized or
 * the phone is rotated.
 */
import { useState, useEffect } from 'react'

export function useMinWidth(px) {
  const [wide, setWide] = useState(() => (typeof window !== 'undefined' ? window.innerWidth >= px : true))
  useEffect(() => {
    const onResize = () => setWide(window.innerWidth >= px)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [px])
  return wide
}
